var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.94531 1.5H18.0545C18.1998 1.5 18.342 1.54221 18.4637 1.62149C18.5855 1.70077 18.6816 1.81371 18.7404 1.94658C18.7992 2.07946 18.8181 2.22655 18.7948 2.36998C18.7716 2.51341 18.7072 2.64699 18.6094 2.7545L12.4449 9.53545C12.3194 9.6735 12.2499 9.85338 12.2499 10.04V15.3486C12.2499 15.4721 12.2194 15.5936 12.1612 15.7025C12.1029 15.8114 12.0187 15.9042 11.9159 15.9726L8.91592 17.9727C8.80297 18.048 8.6717 18.0912 8.53611 18.0977C8.40052 18.1043 8.26569 18.0739 8.14601 18.0099C8.02632 17.9458 7.92626 17.8505 7.8565 17.734C7.78674 17.6176 7.7499 17.4844 7.7499 17.3486V10.04C7.7499 9.85338 7.68036 9.67351 7.55485 9.53545L1.39036 2.7545C1.29262 2.64699 1.22822 2.51341 1.20497 2.36998C1.18173 2.22655 1.20065 2.07946 1.25943 1.94658C1.31821 1.81371 1.41432 1.70077 1.53608 1.62149C1.65785 1.54221 1.80001 1.5 1.94531 1.5V1.5Z",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2601c20b6151353fe4fe89d93b7e14e9.svg";
export { ForwardRef as ReactComponent };